export default {
  'locations': [
    {
      'id': 1,
      'info': {
        'description': '\n        White van speeds south across London Bridge at 80km/h hitting pedestrians just after 10pm on Saturday, June 3. Several people are left dead and injured, with more to come. The terrorist attack mirrors a deadly incident at Westminster Bridge in March, by a “lone wolf” fanatic - and comes less than two weeks after a horrific terror blast at Ariana Grande’s concert in Manchester.\n      ',
        'embed': '\n        <blockquote class="twitter-tweet" data-conversation="none" data-lang="en"><p lang="en" dir="ltr">Here is a picture of the afternath <a href="https://t.co/ZaGbkoZxXE">pic.twitter.com/ZaGbkoZxXE</a></p>&mdash; Brad Myers (@bradnolesbest) <a href="https://twitter.com/bradnolesbest/status/871119471783661573">June 3, 2017</a></blockquote>\n      ',
        'title': 'VAN ATTACK ON LONDON BRIDGE'
      },
      'position': {
        'lat': 51.5081974,
        'lng': -0.0875955
      },
      'pov': {
        'heading': 354,
        'pitch': 0
      },
      'zoom': 1
    },
    {
      'id': 2,
      'info': {
        'description': '\n        The white van, marked with B&Q - a British DIY chain like Bunnings - is dumped on London Bridge Street outside the Barrowboy and Banker pub. Three attackers begin lashing out with knives at revellers enjoying a Saturday night out at the many bars and pubs along the street.\n      ',
        'embed': '\n        <blockquote class="twitter-video" data-lang="en"><p lang="en" dir="ltr"><a href="https://twitter.com/hashtag/LondonBridge?src=hash">#LondonBridge</a> live video clip from shard police have someone can see hear crash was borough market police response superb <a href="https://t.co/jbahhvHFrk">pic.twitter.com/jbahhvHFrk</a></p>&mdash; jo (@jo55adams) <a href="https://twitter.com/jo55adams/status/871129705403076609">June 3, 2017</a></blockquote>\n      ',
        'title': 'VAN ABANDONED, ATTACKERS FLEE ON FOOT'
      },
      'position': {
        'lat': 51.5060776,
        'lng': -0.0886232
      },
      'pov': {
        'heading': 298,
        'pitch': 0
      },
      'zoom': 1
    },
    {
      'id': 3,
      'info': {
        'description': '\n        Terrified diners run for cover as the attackers rampage south down London Bridge Street and nearby roads. The men are wearing canisters around their torsos - fake suicide explosive belts. Some venues open their doors to fugitives, others go into lockdown. Some diners try to fight back by holding doors as the fanatics try to run in and by throwing chairs at them. Among venues caught up in the chaos are Titos restaurant and the Black and Blue steakhouse. Police rush into other pubs like Katzenjammers (see clip), urging drinkers to take cover.\n      ',
        'embed': '\n        <blockquote class="twitter-video" data-lang="en"><p lang="en" dir="ltr">London bridge bar now. Police everywhere <a href="https://t.co/0gWH9jhgdX">pic.twitter.com/0gWH9jhgdX</a></p>&mdash; James Yates (@Yatesy17) <a href="https://twitter.com/Yatesy17/status/871125987613978624">June 3, 2017</a></blockquote>\n      ',
        'title': 'ATTACKERS’ RESTAURANT RAMPAGE'
      },
      'position': {
        'lat': 51.5055109,
        'lng': -0.0884711
      },
      'pov': {
        'heading': 212,
        'pitch': 0
      },
      'zoom': 1
    },
    {
      'id': 4,
      'info': {
        'description': '\n        The attackers make their way to well-known tourist/nightlife destination Borough Market, continuing to stab and slash people at pubs. Police rush to the area within minutes and begin trying to find the perpetrators, shepherding fugitives to safety and clearing the wounded, while the attackers target the Wheatsheaf pub and nearby Southwark Tavern. Spin the image around from the Southwark and you can see how close the Wheatsheaf and the entrance to the market are.\n      ',
        'embed': '<iframe width="400" height="260" src="https://www.youtube.com/embed/ZlFZzOp8N8c" frameborder="0" allowfullscreen></iframe>',
        'title': 'CHAOS AT BOROUGH MARKET'
      },
      'position': {
        'lat': 51.5048783,
        'lng': -0.0906151
      },
      'pov': {
        'heading': 281,
        'pitch': 0
      },
      'zoom': 1
    },
    {
      'id': 5,
      'info': {
        'description': 'With the toll at seven members of the public dead and 48 injured police and army specialists swarming the area corner the three attackers outside the Wheatsheaf pub and shoot them dead, eight minutes after the first emergency calls as the van caused havoc on the bridge. Three hours later - about 1:30am - explosions are heard from inside the market. These are believed to be controlled blasts by the police dealing with the fake suicide vests.',
        'embed': '\n        <blockquote class="instagram-media" data-instgrm-captioned data-instgrm-version="7" style=" background:#2c3e50; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:658px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:8px;"> <div style=" background:##2c3e50; line-height:0; margin-top:40px; padding:37.5% 0; text-align:center; width:100%;"> <div style=" background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURczMzPf399fX1+bm5mzY9AMAAADiSURBVDjLvZXbEsMgCES5/P8/t9FuRVCRmU73JWlzosgSIIZURCjo/ad+EQJJB4Hv8BFt+IDpQoCx1wjOSBFhh2XssxEIYn3ulI/6MNReE07UIWJEv8UEOWDS88LY97kqyTliJKKtuYBbruAyVh5wOHiXmpi5we58Ek028czwyuQdLKPG1Bkb4NnM+VeAnfHqn1k4+GPT6uGQcvu2h2OVuIf/gWUFyy8OWEpdyZSa3aVCqpVoVvzZZ2VTnn2wU8qzVjDDetO90GSy9mVLqtgYSy231MxrY6I2gGqjrTY0L8fxCxfCBbhWrsYYAAAAAElFTkSuQmCC); display:block; height:44px; margin:0 auto -44px; position:relative; top:-22px; width:44px;"></div></div> <p style=" margin:8px 0 0 0; padding:0 4px;"> <a href="https://www.instagram.com/p/BU5JN9hlX-e/" style=" color:#FFF; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none; word-wrap:break-word;" target="_blank">The guy that the police knocked down after 1 min #live #police #dead #man #london #terroristic #attack</a></p> <p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">A post shared by Gabriele Sciotto (@fried_chicken) on <time style=" font-family:Arial,sans-serif; font-size:14px; line-height:17px;" datetime="2017-06-03T21:41:23+00:00">Jun 3, 2017 at 2:41pm PDT</time></p></div></blockquote>\n      ',
        'title': 'COPS FIGHT BACK'
      },
      'position': {
        'lat': 51.5051017,
        'lng': -0.090778
      },
      'pov': {
        'heading': 339,
        'pitch': 0
      },
      'zoom': 1
    },
    {
      'id': 6,
      'info': {
        'description': '\n  As wounded are taken to six hospitals across London, those nearest the scene - Guy’s, St Thomas’ and Evelina - are put in lockdown as a precaution, as are underground stations such as Monument and Bank. Walking wounded are bussed out of the area. This video taken from the Shard high-rise shows the extent of the emergency services operation. It will only get larger as police begin to hunt for helpers of the three main attackers. \n      ',
        'embed': '<blockquote class="twitter-video" data-lang="en"><p lang="en" dir="ltr"><a href="https://twitter.com/hashtag/LondonBridge?src=hash">#LondonBridge</a> right now from the <a href="https://twitter.com/hashtag/Shard?src=hash">#Shard</a> <a href="https://t.co/caX2um8alY">pic.twitter.com/caX2um8alY</a></p>&mdash; Georgia Sibold (@TheGSibold) <a href="https://twitter.com/TheGSibold/status/871144793761624070">June 3, 2017</a></blockquote>',
        'title': 'HOSPITALS, STATIONS LOCKED DOWN'
      },
      'position': {
        'lat': 51.5036465,
        'lng': -0.0876134
      },
      'pov': {
        'heading': 75,
        'pitch': 0
      },
      'zoom': 2
    },
    {
      'id': 7,
      'info': {
        'description': '\n        As day breaks on Sunday police hunting for others behind the attackers raid homes in East London and arrest 12 people - all of them will be released without charge days later. Neighbours of those arrested at a block of flats in Barking told media they he recognised the attackers from news reports. One neighbour said told he how chatted to one of the dead trio just hours before the horror and said the man was a devout Muslim. Meanwhile ISIS claims responsibility. Within days the three are identified as Rachid Redouane, Youssef Zaghba and Khuram Shazad Butt. The latter two were known to Italian and UK authorities, respectively. \n      ',
        'embed': '<blockquote class="twitter-video" data-lang="en"><p lang="en" dir="ltr">Outside <a href="https://twitter.com/hashtag/arqhomes?src=hash">#arqhomes</a> complete no go area <br><br>Public advised to stay away. <a href="https://twitter.com/hashtag/policeraid?src=hash">#policeraid</a> <a href="https://twitter.com/hashtag/PrayForLondon?src=hash">#PrayForLondon</a> <a href="https://twitter.com/hashtag/eastham?src=hash">#eastham</a> <a href="https://twitter.com/hashtag/newham?src=hash">#newham</a> <a href="https://twitter.com/hashtag/NoToTerrorism?src=hash">#NoToTerrorism</a> <a href="https://t.co/Z7O7fk4Rlr">pic.twitter.com/Z7O7fk4Rlr</a></p>&mdash; ARQ HOMES (@ARQHOMESLONDON) <a href="https://twitter.com/ARQHOMESLONDON/status/871377052536111104">June 4, 2017</a></blockquote>',
        'title': 'ARRESTS IN EAST LONDON'
      },
      'position': {
        'lat': 51.5402318,
        'lng': 0.0767775
      },
      'pov': {
        'heading': 351,
        'pitch': 10
      },
      'zoom': 1
    },
    {
      'id': 8,
      'info': {
        'description': '\n  Less than 24 hours after the attack, stars including Take That, Robbie Williams, Justin Bieber, Coldplay, Little Mix, the Black Eyed Peas, Usher, Katy Perry and Ariana Grande gather in a show of solidarity for a benefit gig at Manchester’s Old Trafford stadium. The show was arranged following the horrific bombing at Ariana Grande’s Manchester Arena show by an ISIS fanatic, which killed 22 people. The benefit gig is attended by 50,000 fans and surrounded by a huge security cordon. Meanwhile as tales of public heroism continue to emerge, the dead are identified - among them South Australian nurse Kirsty Boden and Queensland nanny Sara Zelenak. The others are Frenchmen Sebastien Belanger, Alexandre Pigeard, and Xavier Thomas, Canadian woman Christine Archibald, Brit James McMullan and Spaniard Ignacio Echeverria.  \n      ',
        'embed': '<blockquote class="twitter-video" data-lang="en"><p lang="en" dir="ltr">&#39;You are not alone in this&#39; perfect sentiment to open <a href="https://twitter.com/hashtag/OneLoveManchester?src=hash">#OneLoveManchester</a> <a href="https://t.co/Em2ULKWVpU">pic.twitter.com/Em2ULKWVpU</a></p>&mdash; Lucy Jayne Ford (@lucyj_ford) <a href="https://twitter.com/lucyj_ford/status/871428443434569728">June 4, 2017</a></blockquote>',
        'title': 'WE WILL DEFY'
      },
      'position': {
        'lat': 53.4635195,
        'lng': -2.2889322
      },
      'pov': {
        'heading': 248,
        'pitch': 0
      },
      'zoom': 1
    }
  ],
  'selected': {
    'id': 0,
    'info': {
      'image': 'https://storage.googleapis.com/main-street/images/collage.jpg',
      'title': 'Welcome to Main Street'
    },
    'position': {
      'lat': 51.5055109,
      'lng': -0.0884711
    },
    'zoom': 1
  }
}



// WEBPACK FOOTER //
// ./src/assets/data.js